<template>
  <div class="viewOpeningReportAE">
    <div class="cont-box">
      <div class="title">
        <Title text="设计撰写" />
        <!-- <div>
          <el-form
                ref="search"
                :inline="true"
                :model="condition"
                :rules="searchRules"
                class="search-form"
                slot="search"
                label-width="80px"
            >
                <div style="display: flex; justify-content: space-between">
                    <div>
                        <div>
                            <el-form-item prop="paper_plan_id">
                                <el-select
                                    v-model="condition.paper_plan_id"
                                    placeholder="请选择论文计划"
                                    clearable
                                    filterable
                                    style="width: 300px;"
                                >
                                <el-option
                                    v-for="item in thesisPlanList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                                ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="loadData">确认</el-button>
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="isShowDuplicate">
                      <div class="btn-box">
                        <div>
                          <el-form-item>
                            <el-button type="primary" @click="openingReportClick('back')">毕业设计(论文)上传</el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                </div>
            </el-form>
        </div> -->
      </div>
      <div>
        <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="" align="center" label="流程标题">
              <template slot-scope="{row}">
                <span>{{ row.student_title }} + {{ row.process_title }} + {{ row.created_at }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="student_title" align="center" label="学生姓名"></el-table-column> -->
            <el-table-column prop="sign_img" align="center" label="手写签名">
              <template slot-scope="{row}">
                <img :src="row.sign_img" alt="" style="width: 200px;height: 40px;object-fit: contain;">
              </template>
            </el-table-column>
            <el-table-column prop="student_question" align="center" label="学生提问">
              <template slot-scope="{row}">
                <p class="QACont" v-for="(item, index) in row.student_question" :key="index">{{index + 1 + '、' + item.content }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="teacher_guide" align="center" label="老师回复">
              <template slot-scope="{row}">
                <div class="QACont" v-for="(item, index) in row.teacher_guide" :key="index">
                  <span>{{index + 1 + '、'}}</span>
                  <span>{{ item.content }}</span>
                  <div v-if="item.files_url ? true : false">
                    <p v-for="(item2, index2) in JSON.parse(item.files_url)" :key="index2">
                        <span class="file-name">{{ item2.name }}</span>
                        <el-button
                            type="text"
                            size="mini"
                            style="margin-left: 10px;"
                            @click="downloadFiles(item2)"
                        >下载</el-button>
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="teacher_guide" align="center" label="老师回复">
              <template slot-scope="{row}">
                <div class="QACont" v-for="(item, index) in row.teacher_guide" :key="index">
                  <span>{{index + 1 + '、'}}</span>
                  <span>{{ item.content }}</span>
                  <div v-if="item.files_url ? true : false">
                    <p v-for="(item2, index2) in JSON.parse(item.files_url)" :key="index2">
                        <span class="file-name">{{ item2.name }}</span>
                        <el-button
                            type="text"
                            size="mini"
                            style="margin-left: 10px;"
                            @click="downloadFiles(item2)"
                        >下载</el-button>
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="duplicate.check_status" align="center" label="查重附件审核状态">
              <template slot-scope="{row}">
                <el-tag v-if="row.duplicate ? true : false" :type="row.duplicate.check_status | duplicateStatusStyle" size="mini">{{ row.duplicate.check_status | duplicateStatusFilter }}</el-tag>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="duplicate.check_remark" align="center" label="查重附件审核备注"></el-table-column> -->
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="{row}">
                <el-button
                  class="link-btn"
                  type="text"
                  @click="viewQA(row)"
                >查看问答</el-button>
                <!-- <el-button
                  v-if="isStageSubmit == 1"
                  class="link-btn"
                  type="text"
                  @click="duplicateCheck(row)"
                >上传查重附件</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 上传任务书及开题报告/上传资料 -->
      <!-- <el-dialog
        class="openingReport"
        :title="designType === 'phaseOne' ? '任务书及开题报告上传' : '设计(论文)上传'"
        :visible.sync="isShowOpeningReport"
        width="40%"
        @close="openingReportClose"
      >
        <div class="dialog" >
          <el-form
            ref="openingReport"
            :model="openingReportData"
            :rules="openingReportRules"
            label-width="200px"
          >
            <el-form-item label="设计资料文件:" prop="files_url">
              <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
            </el-form-item>
            <el-form-item label="手写签名:" prop="sign_img">
              <esignHandle
                ref="esignHandle"
                :selectSignImg.sync="openingReportData.sign_img"
              ></esignHandle>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowOpeningReport = false">取 消</el-button>
          <el-button type="primary" @click="openingReportSubmit">确 定</el-button>
        </div>
      </el-dialog> -->
      <!-- 查看问答 -->
      <el-dialog
        class="viewQA"
        title="查看问答"
        :visible.sync="isShowViewQA"
        width="40%"
        @close="viewQAClose"
      >
        <div class="dialog">
          <div v-if="QAList.length > 0" class="QA-cont">
            <el-scrollbar ref="viewQAScrollbar" style="height: 360px;">
                <div class="item" v-for="(item, index) in QAList" :key=index>
                    <div v-if="item.type == 1" class="ask">
                        <div class="top">
                            <span class="name">{{ item.student_title }}</span>
                            <span class="time">{{ item.created_at }}</span>
                        </div>
                        <div class="cont">
                            <span class="text">{{ item.content }}</span>
                            <!-- <div v-if="item.imgs_url ? true : false" class="imgs-box">
                                <el-image
                                v-for="(itemImgs, imgsIndex) in item.imgs_url.split(',')" :key="imgsIndex"
                                class="img"
                                :src="itemImgs"
                                fit="contain"
                                :preview-src-list="item.imgs_url.split(',')"
                                ></el-image>
                            </div> -->
                        </div>
                    </div>
                    <div v-if="item.type == 2" class="answer">
                        <div class="top">
                            <span class="name">{{ item.teacher_title }}</span>
                            <span class="time">{{ item.created_at }}</span>
                        </div>
                        <div class="cont">
                            <span class="text">{{ item.content }}</span>
                            <!-- <div v-if="item.imgs_url ? true : false" class="imgs-box">
                                <el-image
                                v-for="(itemImgs, imgsIndex) in item.imgs_url.split(',')" :key="imgsIndex"
                                class="img"
                                :src="itemImgs"
                                fit="contain"
                                :preview-src-list="item.imgs_url.split(',')"
                                ></el-image>
                            </div> -->
                            <div v-if="item.files_url ? true : false" class="imgs-box">
                                <div v-for="(item, index) in JSON.parse(item.files_url)" :key="index">
                                    <span class="file-name">{{ item.name }}</span>
                                    <el-button
                                        type="text"
                                        size="mini"
                                        style="margin-left: 10px;"
                                        @click="downloadFiles(item)"
                                    >下载</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
          </div>
          <el-form
            ref="viewQA"
            :model="viewQAData"
            :rules="viewQARules"
            label-width="80px"
          >
            <el-form-item label="问题内容" prop="content">
                <el-input
                    v-model="viewQAData.content"
                    placeholder="请输入问题内容"
                    type="textarea"
                    rows="3"
                    clearable
                />
              </el-form-item>
              <!-- <el-form-item label="问题图片" prop="imgs_url">
                <FalConUpload
                  ref="QAImgsUpload"
                  :multiple="true"
                  :limit="20"
                  :isShowModal="false"
                  @handleRemove="QAImgsUploadRemove"
                  @handleChange="QAImgsUploadChange"
                ></FalConUpload>
              </el-form-item> -->
            </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowViewQA = false">取 消</el-button>
          <el-button type="primary" @click="viewQASubmit">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 上传查重附件 -->
      <!-- <el-dialog
        class="duplicateCheck"
        title="上传查重附件"
        :visible.sync="isShowDuplicateCheck"
        width="40%"
        @close="duplicateCheckClose"
      >
        <div class="dialog" >
          <el-form
            ref="duplicateCheck"
            :model="duplicateCheckData"
            :rules="duplicateCheckRules"
            label-width="160px"
          >
            <el-form-item label="查重文件:" prop="files_url">
              <FalConUpload
                ref="uploadDuplicateCheck"
                listStyle='text'
                accept=".docx,.doc,.pdf,.txt"
                :limit="1"
                :isFile="true"
                :isAccept="true"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload>
              <div>
                <span style="color: red;">说明：只能上传docx,doc,pdf,txt文件</span>
              </div>
            </el-form-item>
            <el-form-item label="手写签名:" prop="sign_img">
              <esignHandle
                ref="duplicateCheckEsignHandle"
                :selectSignImg.sync="duplicateCheckData.sign_img"
              ></esignHandle>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowDuplicateCheck = false">取 消</el-button>
          <el-button type="primary" @click="duplicateCheckSubmit">确 定</el-button>
        </div>
      </el-dialog> -->
      <!-- 查重记录 -->
      <!-- <el-dialog
        class="duplicateCheckRecord"
        title="查重记录"
        :visible.sync="isShowDuplicateCheckRecord"
        width="50%"
        @close="duplicateCheckRecordClose"
      >
        <div class="cont" >
          <div class="files">
            <div class="title">查重附件</div>
            <div class="item-box">
              <span v-if="duplicateList.length <= 0" class="tips">暂无文件</span>
              <el-scrollbar v-else style="height: 300px;">
                <div v-for="(item, index) in duplicateList" :key="index">
                  <div :class="['item', {'on': duplicateId == item.id}]" v-for="(item2, index2) in JSON.parse(item.files_url)" :key="index2" @click="duplicateClick(item)">
                      <span class="file-name">{{ item2.name }}</span>
                      <el-button
                          type="text"
                          size="mini"
                          style="margin-left: 10px;"
                          @click.stop="downloadFiles(item2)"
                      >下载</el-button>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
          <div class="duplicateCheckRes">
            <div class="title">
              <span>查重结果</span>
              <div v-if="duplicateList.length > 0 && duplicateId" class="status">
                  <el-tag :type="duplicateStatus | duplicateStatusStyle" size="mini">{{ duplicateStatus | duplicateStatusFilter }}</el-tag>
              </div>
            </div>
            <div class="item-box">
              <span v-if="!duplicateRes.paperguid" class="tips">暂无结果</span>
                <el-scrollbar v-else style="height: 300px;">
                    <div class="item">
                        <span class="name">检测报告编码：</span>
                        <span class="value">{{ duplicateRes.paperguid }}</span>
                    </div>
                    <div class="item">
                        <span class="name">检测文章标题：</span>
                        <span class="value">{{ duplicateRes.papertitle }}</span>
                    </div>
                    <div class="item">
                        <span class="name">相似率：</span>
                        <span class="value">{{ duplicateRes.percentage }}</span>
                    </div>
                    <div class="item">
                        <span class="name">检测时间：</span>
                        <span class="value">{{ duplicateRes.checkdate }}</span>
                    </div>
                    <div class="item">
                        <span class="name">检测字数：</span>
                        <span class="value">{{ duplicateRes.paperword }}</span>
                    </div>
                    <div class="item">
                        <span class="name">在线预览链接：</span>
                        <span class="value">
                            <a :href="duplicateRes.paperviewurl" target="_blank">{{ duplicateRes.paperviewurl }}</a>
                        </span>
                    </div>
                    <div class="item">
                        <span class="name">下载报告地址：</span>
                        <span class="value">
                            <a :href="duplicateRes.paperdownurl" target="_blank">{{ duplicateRes.paperdownurl }}</a>
                        </span>
                    </div>
                </el-scrollbar>
            </div>
          </div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <el-button @click="isShowDuplicateCheckRecord = false">关闭</el-button>
        </div>
      </el-dialog> -->
  </div>
</template>

<script>
import {
  adultStudentPpsGetReport,
  adultStudentPpsUpReport,
  adultStudentPpsUpDevise,
  adultStudentPpsGetQa,
  adultStudentPpsUpAa,
  adultStudentPpsUpDuplicate,
  adultStudentPpAll,
  adultStudentPpsDuplicate,
} from "@/api/graduation";
// import FalConUpload from "@/components/uploadFile";
import { putObject, uploadFiles, deleteObject } from "@/utils/upload";

// import esignHandle from '@/components/esignHandle';

import {arrAttDel, deepClone} from '@/utils/func';

import {downladUrl} from '@/utils/func';

export default {
  name: "viewOpeningReportAE",
  // components: { FalConUpload, esignHandle },
  filters: {
    // 查重附加审核状态
    duplicateStatusFilter(v){
        const obj = {
            0: '待检测',
            1: '已通过',
            2: '未通过',
        };
        return obj[v];
    },
    // 查重附件审核状态 样式
    duplicateStatusStyle(v){
        const obj = {
            0: '',
            1: 'success',
            2: 'danger',
        };
        return obj[v];
    },
  },
  data() {
    return {
      condition: {
        paper_plan_id: this.$route.query.paper_plan_student_id,  //论文计划
      },
      // searchRules: {
      //   paper_plan_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
      // },
      thesisPlanList: [],  //论文计划列表
      // isShowDuplicateBtn: true,  //显示上传查重附件按钮
      // isShowDuplicateCheckRecordBtn: true,  //显示查重记录按钮

      isShowDuplicate: false,  //选择论文计划后出现的数据

      list:[],
      listTotal: -1,

      designType: '',  //设计资料类型(任务书及开题报告: phaseOne,设计资料: back)

      // 任务书及开题报告/设计资料文件
      // isShowOpeningReport: false,
      // openingReportData: {
      //   paper_plan_student_id: '',  //论文计划学生id
      //   files_url: '',  //任务书及开题报告文件/设计资料文件
      //   // imgs_url: '',  //任务书及开题报告图片/设计资料图片
      //   sign_img: '',  //手写签名图片地址
      // },
      // openingReportRules: {
      //   files_url: [{ required: true, message: '请上传设计资料文件', trigger: 'change' }],
      //   // imgs_url: [{ required: true, message: '请上传设计资料图片', trigger: 'change' }],
      //   sign_img: [{ required: true, message: '请添加手写签名', trigger: 'change' }],
      // },

      // 查看问答
      isShowViewQA: false,
      viewQAData: {
        defense_process_id: '',  //设计资料id
        content: '',  //问题内容
        // imgs_url: '',  //问题图片
      },
      viewQARules: {
        content: [{ required: true, trigger: 'blur', message: "请输入问题内容" }],
      },
      QAList: [],  //问答列表

      // 上传查重附件
      // isShowDuplicateCheck: false,
      // duplicateCheckData: {
      //   defense_process_id: '',  //设计资料id
      //   files_url: '',  //查重图片
      //   sign_img: '',  //签名图片
      // },
      // duplicateCheckRules: {
      //   files_url: [{ required: true, trigger: 'change', message: "请上传查重文件" }],
      //   sign_img: [{ required: true, trigger: 'change', message: "请上传签名图片" }],
      // },

      // duplicateList: [],  //查重附件列表

      // 查重记录
      // isShowDuplicateCheckRecord: false,
      // duplicateStatus: 0,  //0待检测 1已通过 2未通过
      // duplicateId: null,  //查重附件 id
      // //查重结果
      // duplicateRes: {
      //     paperguid: '',  //检测报告编码
      //     papertitle: '',  //检测文章标题
      //     percentage: '',  //相似率
      //     checkdate: '',  //检测时间
      //     paperword: '',  //检测字数
      //     paperviewurl: '',  //在线预览链接
      //     paperdownurl: '', //下载报告地址
      // },

      // endUploadTime: '',  //截止时间

    };
  },
  watch: {
      // 监听 弹窗 查看问答 显示
      isShowViewQA(v){
          if(v){
              if(this.QAList.length > 0){
                  this.$nextTick(() => {
                      // 设置滚动底部
                      this.$refs['viewQAScrollbar'].wrap.scrollTop = this.$refs['viewQAScrollbar'].wrap.scrollHeight;
                  });
              }
          }
      },
  },
  created() {
    this.getListFn();
    // this.getThesisPlanList();
  },
  methods: {
    // 点击查重附件
    // duplicateClick(item){
    //     this.duplicateId = item.id;
    //     this.duplicateStatus = item.check_status;
    //     this.duplicateRes = item.result;
    // },
    // 弹窗 查重记录 关闭
    // duplicateCheckRecordClose(){
    //   this.isShowDuplicateCheckRecord = false;
    //   this.duplicateStatus = 0;
    //   this.duplicateId = null;
    //   this.duplicateRes = {
    //       paperguid: '',  //检测报告编码
    //       papertitle: '',  //检测文章标题
    //       percentage: '',  //相似率
    //       checkdate: '',  //检测时间
    //       paperword: '',  //检测字数
    //       paperviewurl: '',  //在线预览链接
    //       paperdownurl: '', //下载报告地址
    //   };
    // },
    // 点击查重记录
    // duplicateCheckRecordClick(){
    //   this.getDuplicateList();
    //   this.isShowDuplicateCheckRecord = true;
    // },
    // 获取查重附记录
    // getDuplicateList(){
    //     let data = {
    //         paper_plan_student_id: this.condition.paper_plan_id
    //     };
    //     adultStudentPpsDuplicate(data).then(res => {
    //         this.duplicateList = res.result;
    //         //默认选中第一个
    //         this.duplicateId = res.result[0].id;
    //         this.duplicateRes = res.result[0].result;
    //     });
    // },
    // 弹窗 查看问答 文件下载
    downloadFiles(row){
      downladUrl(row.url, row.name);
    },
    // 选择资料确认
    // loadData(){
    //   this.$refs["search"].validate((valid) => {
    //     if (valid) {
    //       this.getListFn();
    //       let curItem = this.thesisPlanList.find(item => item.id === this.condition.paper_plan_id);
    //       // this.endUploadTime = curItem.end_upload_time;
    //       // this.isShowDuplicateBtn = curItem.process_status < 3;
    //       // this.isShowDuplicateCheckRecordBtn = curItem.is_devise_submit == 1;
    //     }
    //   });
    // },
    // 获取论文计划
    // getThesisPlanList(){
    //   adultStudentPpAll().then(res => {
    //     this.thesisPlanList = res.result;
    //   });
    // },
    // 弹窗 上传查重附件 提交
    // duplicateCheckSubmit(){
    //   this.$refs["duplicateCheck"].validate((valid) => {
    //     if (valid) {
    //       uploadFiles(this.duplicateCheckData.files_url, (urls) => {
    //         let data = deepClone(this.duplicateCheckData);
    //         data.files_url = urls;
    //         adultStudentPpsUpDuplicate(data).then(res => {
    //           if(res.code == 200){
    //             this.$message.success('保存成功');
    //             this.isShowDuplicateCheck = false;
    //             window.open(res.result.redirect_url, '_blank');
    //           }
    //         });
    //       }, null, 'student', '', true);
    //     }
    //   })
    // },
    // 查重附件 图片 删除
    // duplicateCheckHandleRemove(data){
    //   this.duplicateCheckData.files_url = data.fileList;
    //   // let fileName = data.file.name;
    //   // let imgsUrlArr = JSON.parse(this.duplicateCheckData.imgs_url);
    //   // this.duplicateCheckData.files_url = arrAttDel(imgsUrlArr, 'name', fileName, 'json');
    // },
    // 查重附件 图片 多传
    // duplicateCheckHandleChange(data){
    //   this.duplicateCheckData.files_url = data.fileList;
    //   // uploadFiles(data.fileList, (urls) => {
    //   //   this.duplicateCheckData.files_url = urls;
    //   // }, null, 'student', '', true);
    // },
    // 弹窗 上传查重附件 关闭
    // duplicateCheckClose(){
    //   this.duplicateCheckData = {
    //     defense_process_id: '',  //设计资料id
    //     imgs_url: '',  //查重图片
    //     sign_img: '',  //签名图片
    //   };
    //   this.$refs['uploadDuplicateCheck'].reset();
    //   this.$refs['duplicateCheckEsignHandle'].handleReset();  //签名这块清空
    //   this.$nextTick(() => {
    //       this.$refs["duplicateCheck"].clearValidate();
    //   });
    // },
    // 点击 上传查重附件
    // duplicateCheckClick(){
    //   this.duplicateCheckData.paper_plan_student_id = this.condition.paper_plan_id;
    //   this.isShowDuplicateCheck = true;
    // },
    // 弹窗 查看问答 提交
    viewQASubmit(){
        this.$refs["viewQA"].validate((valid) => {
            if (valid) {
              // uploadFiles(this.viewQAData.imgs_url, urls => {
                let data = deepClone(this.viewQAData);
                // data.imgs_url = urls;
                adultStudentPpsUpAa(data).then(res => {
                  if(res.code == 200){
                    this.$message.success('保存成功');
                    this.isShowViewQA = false;
                    // this.getListFn();
                  }
                });
              // });
            }
        });
    },
    // 弹窗 查看问答 上传图片
    // QAImgsUploadChange(val){
    //   this.viewQAData.imgs_url = val.fileList;
    //   // uploadFiles(val.fileList, (urls) => {
    //   //   this.viewQAData.imgs_url = urls;
    //   // });
    // },
    // 弹窗 查看问答 移除图片
    // QAImgsUploadRemove(data){
    //   this.viewQAData.imgs_url = data.fileList;
    // },
    // 弹窗 查看问答 关闭
    viewQAClose(){
        this.viewQAData = {
          defense_process_id: '',  //设计资料id
          content: '',  //问题内容
          // imgs_url: '',  //问题图片
        };
        // this.$refs['QAImgsUpload'].reset();
        this.$nextTick(() => {
            this.$refs["viewQA"].clearValidate();
        });
    },
    // 点击 查看问答
    async viewQA(row){
        this.viewQAData.defense_process_id = row.id;
        const {result} = await this.getQAData(row.id);
        if(result.length > 0){
          this.QAList = result;
        }else{
          this.QAList = [];
        }
        this.isShowViewQA = true;
    },
    // 获取问答
    getQAData(defense_process_id){
      return new Promise((resolve, reject) => {
        const data = {
          defense_process_id
        }
        adultStudentPpsGetQa(data).then(res => {
          resolve(res);
        });
      })
    },
    // 弹窗 任务书及开题报告上传/设计(论文)上传 提交
    // openingReportSubmit(){
    //   this.$refs["openingReport"].validate(async (valid) => {
    //     if (valid) {
    //       uploadFiles(this.openingReportData.files_url, async (urls) => {
    //         let data = deepClone(this.openingReportData);
    //         data.files_url = urls;
    //         let res;
    //         if(this.designType === 'phaseOne'){
    //           // 任务书及开题报告上传
    //           res= await adultStudentPpsUpReport(data);
    //         }else if(this.designType === 'back'){
    //           // 上传资料
    //           res= await adultStudentPpsUpDevise(data);
    //         }
    //         if(res.code == 200){
    //           this.$message.success('保存成功');
    //           this.isShowOpeningReport = false;
    //           this.getListFn();
    //         }
    //       }, null, 'student', '', true);
    //     }
    //   })
    // },
    // 弹窗 任务书及开题报告/设计资料 关闭
    // openingReportClose(){
    //   this.openingReportData = {
    //     paper_plan_student_id: '',  //论文计划学生id
    //     files_url: '',  //任务书及开题报告文件/设计资料文件
    //     // imgs_url: '',  //任务书及开题报告图片/设计资料图片
    //     sign_img: '',  //手写签名图片地址
    //   };
    //   this.$refs['uploadFile'].reset();
    //   // this.$refs['uploadPaperPictures'].reset();
    //   this.$refs['esignHandle'].handleReset();  //签名这块清空
    //   this.$nextTick(() => {
    //     this.$refs['openingReport'].clearValidate();
    //   });
    // },
    // 任务书及开题报告/设计资料 图片 删除
    // paperPicturesHandleRemove(data){
    //   let fileName = data.file.name;
    //   let filesUrlArr = JSON.parse(this.openingReportData.imgs_url);
    //   this.openingReportData.imgs_url = arrAttDel(filesUrlArr, 'name', fileName, 'json');
    // },
    // 任务书及开题报告图片  多传
    // paperPicturesHandleChange(val){
    //   uploadFiles(val.fileList, (urls) => {
    //     this.openingReportData.imgs_url = urls;
    //   }, null, 'student', '', true);
    // },
    // 上传 任务书及开题报告文件/设计资料文件
    // handleChangeFile(data) {
    //   this.openingReportData.files_url = data.fileList;
    //   // uploadFiles(data.fileList, (urls) => {
    //   //   this.openingReportData.files_url = urls;
    //   // }, null, 'student', '', true);
    // },
    //  删除 任务书及开题报告文件/设计资料文件
    // handleRemoveFile(data) {
    //   this.openingReportData.files_url = data.fileList;
    //   // let fileName = data.file.name;
    //   // let filesUrlArr = JSON.parse(this.openingReportData.files_url);
    //   // this.openingReportData.files_url = arrAttDel(filesUrlArr, 'name', fileName, 'json');
    // },
    // 点击 任务书及开题报告/设计资料
    // openingReportClick(type){
    //   this.designType = type;
    //   this.openingReportData.paper_plan_student_id = this.condition.paper_plan_id;
    //   this.isShowOpeningReport = true;
    // },
    // 获取数据
    getListFn(){
      let data = {
          paper_plan_student_id: this.condition.paper_plan_id
      };
      adultStudentPpsGetReport(data).then(res => {
          if(res.code == 200){
              this.list = res.result;
              this.isShowDuplicate = true;
          }
      });
    },
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss">
  .viewOpeningReportAE{
    .el-scrollbar{
      padding-bottom: 20px;
      .el-scrollbar__wrap{
        overflow-x: hidden;  // 隐藏自带的滚动条
      }
    }
  }
</style>

<style lang="scss" scoped>
.viewOpeningReportAE {
    min-height: $contentH;
    padding: $sideMargin;
    padding-bottom: 0;
  .cont-box{
    background: $white;
    min-height: inherit;
    padding: 0 20px 20px;
    .title{
      .btn-box{
          display: flex;
          justify-content: space-between;
      }
    }
  }
  .QACont{
    text-align: left;
  }
  .viewQA{
    .QA-cont{
      .item{
          .ask,
          .answer{
              .top{
                  padding: 10px 0;
                  display: flex;
                  justify-content: space-between;
                  .name{
                      font-size: 16px;
                      font-weight: bold;
                  }
                  .time{
                      font-size: 12px;
                      color: #666;
                  }
              }
              .cont{
                  // margin-left: 20px;
                  padding: 10px;
                  border-radius: 4px;
                  .text{}
                  .imgs-box{
                      .img{
                          width: 100px;
                          height: 100px;
                          margin-right: 10px;
                      }
                  }
              }
          }
          .ask{
              .cont{
                  background-color: #eee;
              }
          }
          .answer{
              .cont{
                  border: 1px solid #eee;
              }
          }
      }
    }
  }
  .tips{
    font-size: 12px;
    color: #999;
  }
  // 查重记录
  .duplicateCheckRecord{
    .cont{
      display: flex;
      justify-content: space-between;
      border: 1px solid #eee;
      .files,
      .duplicateCheckRes{
        width: 50%;
        .title{
          border-bottom: 1px solid #eee;
          padding: 10px;
          font-size: 16px;
        }
        .item-box{
          padding: 10px;
          .item{
            padding: 5px 10px 5px 0;
          }
        }
      }
      .files{
        border-right: 1px solid #eee;
        .item-box{
          .item{
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            &.on,
            &:hover{
                background-color: #F5F7FA;
                .file-name{
                    color: #66b1ff;
                }
            }
          }
        }
      }
      .duplicateCheckRes{
        .title{
          display: flex;
          justify-content: space-between;
        }
        .item-box{
          .item{
            .name{
              font-weight: bold;
            }
          }
        }

      }
    }
  }
}
</style>
